<div class="container-fluid bg-white">
    <div class="container ">
        <div class="row">
            <div class="col-12 col-lg-6 py-5">
                <p class="secondary-funds-600 tab-ancla mb-2">¿POR QUÉ MYINVESTOR?</p>
                <h2 class="primary-900 mb-2">MyInvestor es un banco experto en inversión. Está respaldado por el Grupo
                    Andbank, El Corte Inglés Seguros, AXA España y varios 'family office'</h2>
                <p class="p1-regular primary-900">MyInvestor Banco, S.A. es una entidad de crédito supervisada por el Banco de
                    España y la CNMV. Además, tus ahorros están garantizados por el Fondo de Garantía de Depósitos
                    Español.</p>
            </div>
            <div class="col-12 col-lg-6 background-acuerdo"> </div>
        </div>

        <div class="border-top-1 border-secondary-funds-700 mb-4"></div>

        <div class="row">
            <div class="col-12">
                <p class="secondary-funds-600 tab-ancla">¿QUÉ PRODUCTOS OFRECEMOS?</p>
                <app-ficha-productos-funds></app-ficha-productos-funds>
            </div>
        </div>
    </div>